export const GoogleAnalytics4Tags = {
    eventAction: {
        click: 'click',
        load: 'load',
        select: 'select'
    },
    eventActionKey: {
        click: 'click_item',
        load: 'load_item',
        select: 'selected_item',
        loadUser: 'user_id'
    },
    partnerId: {
        name: 'partner_id',
        click: {},
        load: {
            affiliateID: '{affiliateID}'
        },
        select: {}
    },
    login: {
        name: 'login',
        click: {
            becomeAPartnerCTA: 'become_a_partner_cta_clicked',
            CTA: 'log_in_cta_clicked',
            forgotPasswordLink: 'forgot_password_link_clicked'
        },
        load: {
            loginSuccessful: 'log_in_successful',
            invalidCredentials: 'invalid_credentials_error_loaded'
        },
        select: {

        }
    },
    referralType: {
        name: 'referral_type',
        click: {
            referralTypeValue: '{referral_type_value}'
        },
        load: {},
        select: {}
    },
    referAClient: {
        name: 'refer_a_client',
        click: {
            individualButton: 'an_individual_button_clicked',
            companyButton: 'a_company_button_clicked',
            partnerButton: 'a_partner_button_clicked',
            confirmationCTA: 'confirmation_confirm_cta_clicked',
        },
        load: {
            personalDetailsPageLoad: 'personal_details_pageload',
            contactDetailsPageLoad: 'contact_details_pageload',
            transactionDetailsPageLoad: 'transaction_details_pageload',
            requirementDetailsPageLoad: 'requirements_pageload',
            confirmationPageLoad: 'confirmation_pageload',
            clientSuccessfullyReferredPageLoad: 'client_successfully_referred_pageload'
        },
        select: {
            contactDetailsBestTimeToCall: 'contact_details_best_time_to_call_{{timeToCall}}',
            transactionDetails: {
                estimatedTransactionValue: 'transaction_details_estimated_transaction_value_{{transactionValue}}',
                currencyYourClientHas: 'transaction_details_currency_your_client_has_{{currencyClientHas}}',
                currencyYourClientWants: 'transaction_details_currency_your_client_wants_{{currencyClientWants}}',
                reasonForTransferring: 'transaction_details_Reason_for_transferring_{{reasonForTransferring}}', //corresponding UI element removed
            },
            requirementDetails: {
                affiliateReferredClientTypes: 'requirements_client_type_{{affiliate_client_types}}'
            }
        }
    },
    clientManagement: {
        name: 'client_managment',
        click: {
            filterTableCTA: 'client_management_filter_cta_clicked',
            exportTableCTA: 'client_management_export_cta_clicked',
            viewDetailsButton: 'client_management_view_details_cta_clicked'
        },
        load: {
            clientManagementPageLoad: 'client_management_pageload'
        }
    },
    registration: {
        name: 'create_an_account',
        click: {
            cta: 'Register_a_customer_cta_clicked',
            confirmCTA: 'confirmation_confirm_cta_clicked',
        },
        load: {
            personalDetailsPageLoad: 'personal_details_pageload',
            loginPageLoad: 'login_details_pageload',
            bankDetailsPageLoad: 'bank_details_pageload',
            clientDetailsPageLoad: 'your_clients_pageload',
            confirmationPageLoad: 'confirmation_pageload',
            registrationComplete: 'registration_complete_pageload'
        },
        select: {
            bankDetailsPaymentCurrency: 'bank_details_payment_currency_{{paymentCurrency}}',
            bankDetailsPaymentCountry: 'bank_details_payment_country_{{paymentCountry}}',
            affiliateBusinessSector: 'your_business_sector_{{your_business_sector}}',
            affiliateBusinessCategory: 'your_business_category_{{your_business_category}}',
            whichCountriesBased: 'your_clients_which_countries_are_your_clients_based_in_{{clientCountries}}',
            whichLanguagesSpeak: 'your_clients_which_languages_do_you_clients_speak_{{clientLanguages}}',
            whichIndustriesOperate: 'your_clients_which_industries_do_you_operate_in_{{industries}}',
            whichClientsService: 'your_clients_which_clients_do_you_service_{{clientService}}',
        }
    },
    registrationV2: {
        name: 'create_an_account',
        click: {
            firstName: 'first_name_field_interaction',
            lastName: 'surname_field_interaction',
            mobile: 'mobile_field_interaction',
            email: 'email_address_interaction',
            password: 'password_field_interaction',
            backToLoginCTA: 'back_to_login_cta_clicked',
            terms: 'terms_and_conditions_clicked',
            confirmCTA: 'confirm_cta_clicked',
        },
        load: {
            becomePartnerPageLoad: 'personal_details_pageload',
            registrationComplete: 'registration_complete_pageload'
        },
        select: {
            businessCategory: 'professional_category_{{businessCategory}}'
        }
    },
    registerClient: {
        name: 'register_a_client',
        click: {
            identityDocumentOptionsByCountry: 'identity_documents_see_options_by_country_clicked',
            confirmationCtaClicked: 'confirmation_continue_cta',
            identityDocumentsSkipThisStepClicked: 'identity_documents_skip_this_step_clicked',
            contactYourPartnerManagerRegisterNewClientCtaClicked: 'registration_failed_contact_your_partner_manage_Register_new_client_cta_clicked',//not in master sheet,
            whyDoWeNeedThisLinkClicked: 'client_details_why_do_we_need_this',
            clientDetailsContinueCtaClicked: 'client_details_continue_cta',
            addressDetailsContinueCtaClicked: 'address_details_continue_cta',
            addressDetailsRequiresJointAccountTicked: 'address_details_requires_a_joint_account_ticked',
            addressDetailsBackCtaClicked: 'address_details_back_cta',
            confirmationBackCtaClicked: 'confirmation_back_cta',
            poiPoaSkipThisStep: 'poi_&_poa_skip_this_step',
            clientRegistrationCompleteNewCustomerCta: 'client_registration_complete_new_customer_cta',
            clientRegistrationCompleteBackToClientManagementCta: 'client_registration_complete_back_to_client_management_cta',
            clientRegistrationFailedNewCustomerCta: 'client_registration_failed_new_customer_cta',
            clientRegistrationFailedBackToClientManagementCta: 'client_registration_failed_back_to_client_management_cta',
            poiSkipThisStep: 'poi_skip_this_step',
            poaSkipThisStep: 'poa_skip_this_step'
        },
        load: {
            customerDetailsPageLoad: 'client_details_pageload',
            addressDetailsPageLoad: 'address_details_pageload',
            preferencesPageLoad: 'preferences_pageload',
            confirmation: 'confirmation_pageload',
            identityDocumentsPageLoad: 'identity_documents_pageload',
            contactYourPartnerManagerPageLoad: 'registration_failed_contact_your_partner_manager_pageload',//not in master sheet 
            registrationLoaderPageLoad: 'registration_loader_pageload',
            poiPoaPageLoad: 'poi_&_poa_pageload',
            clientRegistrationCompletePageLoad: 'client_registration_complete_pageload',
            clientRegistrationFailedPageLoad: 'client_registration_failed_pageload',
            poiPageLoad: 'poi_pageload',
            poaPageLoad: 'poa_pageload',
        },
        select: {
            transactionDetails: {
                estimatedTransactionValue: 'preferences_estimated_amount_{{transactionValue}}',
                currencyYourClientHas: 'transaction_details_currency_your_client_has_{{currencyClientHas}}',//not in master sheet
                currencyYourClientWants: 'transaction_details_currency_your_client_wants_{{currencyClientWants}}'//not in master sheet
            },
            identityDocument: {
                bankStatement: 'identity_documents_Bank_statement_selected',
                utilityBill: 'identity_documents_Utility_bill_selected',
                phoneBill: 'identity_documents_Phone_bill_selected',
                other: 'identity_documents_Other_selected',
                passport: 'identity_documents_Passport_selected',
                nationalIdCard: 'identity_documents_National_ID_card_selected',
                drivingLicense: 'identity_documents_Driving_license_selected',
            },
            clientDetailsEmployment: 'client_details_employment_{{employmentStatus}}',
            clientDetailsWorkIndustry: 'client_details_work_industry_{{workIndustry}}',
            address: {
                addressDetailsCountry: 'address_details_country_{{country}}'
            }
        }
    },

    referralUrlGenerator: {
        name: 'referral_url_generator',
        click: {
            referralURLGeneratorGenerateURLCTA: 'generate_url_cta_clicked',
        },
        load: {
            referralURLGeneratorPageLoad: 'generate_url_pageload',
            referralURLGeneratorSuccessfully: 'url_sent_successfully',
            referralURLGeneratorFail: 'url_send_error'
        },
        select: {
        }
    },
    settings: {
        name: 'settings',
        click: {

        },
        load: {

        },
        select: {
            whichClientsDoYouService: 'which_clients_do_service_{{clients}}',
            whichCountriesAreYourClientsBasedIn: 'which_countries_are_your_clients_based_in_{{countries}}',
            languages: 'languages_{{languages}}',
            whatUpdatesWouldYouLikeFromUs: 'what_updates_would_you_like_from_us_{{updates}}', //Tag not in use
            emailPreferences: 'email_preferences_{{emailPreferences}}',
            whichIndustriesYouOperate: 'who_are_your_customers_{{industry}}',
        }
    },
    accounts: {
        name: 'account',
        click: {
            summaryViewDetails: 'account_summary_view_details_clicked',
            tooltip: {
                referrals: 'your_referrals_tooltip_clicked', //corresponding UI element removed
                registrations: 'registrations_tooltip_clicked', //corresponding UI element removed
                tradedAccounts: 'traded_accounts_tooltip_clicked', //corresponding UI element removed
                balance: 'balance_tooltip_clicked',
                generatedLastMonth: 'generated_last_month_tooltip_clicked', //corresponding UI element removed
                generatedLastQuarter: 'generated_last_qrtr_tooltip_clicked',
                paidLastQuarter: 'paid_last_qrtr_tooltip_clicked',// Not In master
            },
            commissionsGeneratedViewDetails: 'commisions_generated_view_details_clicked',
            annualSummaryDownload: 'annual_summary_download_clicked',

            radioButton: {
                generated: 'generated_radio_button_clicked', // Not In master
                paid: 'paid_radio_button_clicked' // Not In master
            }
        },
        load: {

        },
        select: {

        }
    },
    commissions: {
        name: 'commissions',
        click: {
            radioButton: {
                generated: 'generated_radio_button_clicked',
                paid: 'paid_radio_button_clicked'
            },
            tooltip: {
                balance: 'balance_tooltip_clicked',
                generatedLastMonth: 'generated_last_month_tooltip_clicked', //corresponding UI element removed
                generatedLastQuarter: 'generated_last_qrtr_tooltip_clicked',
                paidLastMonth: 'paid_last_month_tooltip_clicked', //corresponding UI element removed
                paidLastQuarter: 'paid_last_qrtr_tooltip_clicked',
            },
            downloadLink: 'download_link_clicked',
            firstTier: 'first_tier_clicked',
            secondTier: 'second_tier_clicked',
            thirdTier: 'third_tier_clicked'
        },
        load: {

        },
        select: {
            filterMonth: 'filter_month_{{filterMonth}}'
        }
    },
    referrals: {
        name: 'referrals',
        click: {
            tooltip: {
                yourReferrals: 'your_referrals_tooltip_clicked', //corresponding UI element removed
                registration: 'registrations_tooltip_clicked', //corresponding UI element removed
                tradedAccounts: 'traded_accounts_tooltip_clicked', //corresponding UI element removed
            },
            radioButton: {
                referrals: 'referrals_radio_button_clicked',
                registrations: 'registrations_radio_button_clicked',
                tradedAccounts: 'traded_accounts_radio_button_clicked',
            },
            filter: {
                referral: 'filter_referrals_clicked',
                registration: 'filter_registrations_clicked',
                trades: 'filter_trades_clicked'
            },
            downloadLink: 'download_link_clicked',
        },
        load: {

        },
        select: {
            filterMonth: 'filter_month_{{filterMonth}}'
        }
    },
    resources: {
        name: 'resources',
        click: {
            loadMoreCTA: 'load_more_cta_clicked',
            affiliateTrackingCodeLink: 'affiliate_tracking_code_link_clicked'
        },
        load: {

        },
        select: {
            filter: {
                categories: 'filter_Categories_{{filterCategories}}',
                industry: 'filter_Industry_{{filterIndustry}}',
                clientType: 'filter_Client_type_{{filterClientType}}',
                countries: 'filter_countries_{{filterCountries}}'
            }
        }
    },
    globalCTAs: {
        name: 'global_ctas',
        click: {
            sendRegistrationLink: 'send_registration_link_cta_clicked',
            makeAReferral: 'make_a_referral_cta_clicked',
            registerAClientClicked: 'register_a_customer_cta_clicked',
        }
    },
    menuClicks: {
        name: 'menu_clicks',
        click: {
            contact: 'contact',
            account: 'account',
            makeAReferral: 'make_a_referral',
            clientManagement: 'client_management',
            resources: 'resources',
            referralActivity: 'referral_activity',
            commissions: 'commissions',
            invoices: 'invoices',
            settings: 'settings'
        }
    }
};
